import {call, put} from "redux-saga/effects"
import actions from "../../../graphql/actions/service"

export function *getService() {
    const services = yield call(actions.getService)
    yield put({type: 'SET_SERVICE', payload: services})
}
